import { useEffect, useState } from 'react';

export function useScrollSpy(sectionIds, offset = 100) {
  const [activeSection, setActiveSection] = useState(sectionIds[0] || 'home');

  useEffect(() => {
    const resolveActive = () => {
      let current = sectionIds[0] || 'home';

      for (const sectionId of sectionIds) {
        const element = document.getElementById(sectionId);
        if (!element) continue;

        const { top } = element.getBoundingClientRect();
        if (top <= offset) {
          current = sectionId;
        }
      }

      setActiveSection(current);
    };

    resolveActive();
    window.addEventListener('scroll', resolveActive, { passive: true });
    window.addEventListener('resize', resolveActive);

    return () => {
      window.removeEventListener('scroll', resolveActive);
      window.removeEventListener('resize', resolveActive);
    };
  }, [sectionIds, offset]);

  return activeSection;
}
